// src/api/admin.ts
import { supabase } from "../lib/supabaseClient";

export type TopTrip = {
  trip_id: string;
  trip_name: string;
  score: number;
  breakdown: {
    program_items?: number;
    documents?: number;
    expenses?: number;
    payments?: number;
    participants?: number;
    todos?: number;
    quiz_q?: number;
    suggestions?: number;
  };
};

export async function fetchAdminTopTrips(params: {
  start: string;   // 'YYYY-MM-DD'
  end: string;     // 'YYYY-MM-DD'
  limit?: number;  // default 10
  weights?: Partial<Record<keyof TopTrip["breakdown"], number>>;
}) {
  const { start, end, limit = 10, weights } = params;
  const { data, error } = await supabase.rpc("admin_top_trips", {
    p_start: start,
    p_end: end,
    p_limit: limit,
    ...(weights ? { p_weights: weights } : {}),
  });
  if (error) throw error;
  return data as TopTrip[];
}
